import React from 'react'
import Messenger from 'components/stream-messaging/messenger'

const MessagingPage = () => <Messenger />

export default MessagingPage
